<script>
import Layout from "@/router/layouts/franchise";
import { VclList } from "vue-content-loading";
import { api } from "@/state/services";
import Stat from "@/components/widgets/stat";

export default {
  locales: {
    pt: {
      Inventory: "Inventário",
      Products: "Produtos",
      "No records found.": "Nenhum registro encontrado.",
      Total: "Total",
      Available: "Disponível",
      Reserved: "Reservado",
      Name: "Nome",
      Price: "Preço",
    },
    es: {
      Inventory: "Inventario",
      Products: "Productos",
      "No records found.": "No se encontraron registros.",
      Total: "Total",
      Available: "Disponible",
      Reserved: "Reservado",
      Name: "Nombre",
      Price: "Precio",
    },
  },
  components: {
    Layout,
    VclList,
    Stat
  },
  data() {
    return {
      products: null,
      statData: null,
    };
  },
  methods: {
    getInventory() {
      api
        .get("franchise/inventory")
        .then((response) => {
          if (response.data.status == "success") {
            this.products = response.data.list;

            this.statData = [
              {
                icon: "bx bx-dollar",
                title: this.t("Total"),
                value: this.$options.filters.currency(response.data.value),
              },
            ];
          } else {
            this.products = [];
          }
        })
        .catch((error) => {
          if (error) {
            this.products = [];
          }
        });
    },
  },
  mounted() {
    this.getInventory();
  },
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex justify-content-between">
          <h4 class="mb-0 font-size-18">
            {{ t("Inventory") }} › {{ t("Products") }}
          </h4>
        </div>
      </div>
    </div>

    <div class="row">
      <div v-for="stat of statData" :key="stat.icon" class="col-md-4">
        <Stat :icon="stat.icon" :title="stat.title" :value="stat.value" />
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <vcl-list v-if="!products" class="col-lg-6"></vcl-list>
              <template v-else-if="products.length == 0">
                {{ t("No records found.") }}
              </template>
              <table v-else class="table table-nowrap table-hover">
                <thead class="thead-light">
                  <tr>
                    <th style="width: 1%"></th>
                    <th class="text-center" style="width: 1%">{{ t("Total") }}</th>
                    <th class="text-center" style="width: 1%">{{ t("Available") }}</th>
                    <th class="text-center" style="width: 1%">{{ t("Reserved") }}</th>
                    <th>{{ t("Name") }}</th>
                    <th class="text-right">{{ t("Price") }}</th>
                    <th class=" text-right">{{ t("Total") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(pro, index) in products" :key="index">
                    <td class="py-1">
                      <div class="pt-1">
                        <span class="rounded-circle" :style="'float:left; background:' +
                          pro.color +
                          '; width:13px; height:13px;'
                          "></span>
                      </div>
                    </td>
                    <td class="text-center py-1">{{ pro.total }}</td>
                    <td class="text-center py-1">{{ pro.available }}</td>
                    <td class="text-center py-1">{{ pro.reserved }}</td>
                    <td class="py-1">{{ pro.name }}</td>
                    <td class="text-right">{{ pro.price | currency }}</td>
                    <td class="text-right">{{ pro.value | currency }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
